import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Globals } from '../globals';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { PermisoService } from './permiso.service';
import { GeneralService } from './general.service';

@Injectable()
export class DireccionService {
  constructor(
    private http: HttpInterceptor,
    private globals: Globals,
    private general: GeneralService,
    private permisoService: PermisoService) {
  }

  getPaises(): Observable<any> {
    return this.permisoService.getPermisoAction('PAISES-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo                
        return this.http
          .post(
            this.general.webserver + controllerAction, JSON.stringify({
              idCliente: localStorage.getItem('idCliente')
            }));
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getProvincias(IdPais: number): Observable<any> {
    return this.permisoService.getPermisoAction('PROVINCIAS-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo                
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente'),
              IdPais: IdPais
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  // A diferencia de "getPaises" trae los paises desde una tabla más reciente y más cargada de información
  getPais(): Observable<any> {
    return this.permisoService.getPermisoAction('PAIS-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction, JSON.stringify({
              idCliente: localStorage.getItem('idCliente')
            }));
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }
}